import React from "react";

import { useTranslation } from "react-i18next";

import { constants } from "@gp/offer";

export function BettingTypeColumnTip(props: { tip: string }) {
	const { t } = useTranslation();

	const { tip } = props;

	// Even tho configuration contains ONLY empty placeholder we added an option for other elements
	if (
		[
			constants.setnrPlaceholder,
			constants.gamenrPlaceholder,
			constants.marginPlaceholder,
			constants.emptyPlaceholder,
		].includes(tip)
	) {
		return <div className="offer__type__col">&nbsp;</div>;
	}

	return (
		<div className="offer__type__col">
			{t([`BETTING_TYPE.TIPS.${tip}`, tip])}
		</div>
	);
}
